import { getUrlWithId, usePostFetch } from '../utils/reactQuery';
import { ApiRoutesEnum } from '../utils/routes';

export type FetchFilestorageTokenResponseType = {
  token: string;
};

export const useGetFileStorageToken = (id: string) => {
  const url = id ? getUrlWithId(ApiRoutesEnum.fileStorage, id).concat('/token') : '';
  return usePostFetch<FetchFilestorageTokenResponseType>(url);
};
